import { toast } from "react-toastify";
import { axios } from "../../../utils/axios";
import { toastOptions } from "../../../config/toast";

export const handleBusquedaPorRangoDeFechas = async (submittedData, setCamaras, setError) => {
  setCamaras((prevState) => ({
    ...prevState,
    is_loading: true,
  }));

  const result = await axios().post("/camaras_por_fecha", submittedData);
  const { status } = result;
  const { data, error } = result.data;

  if (data) {
    setCamaras((prevState) => ({
      ...prevState,
      fecha_inicio: submittedData.fecha_inicio,
      fecha_fin: submittedData.fecha_fin,
      data: data,
      is_loading: false,
    }));
  }

  if (error) {
    if (status !== 422) {
      toast.error(error, toastOptions);
    } else {
      Object.entries(error).forEach((err, i) => {
        setError(err[0], { type: err[0], message: err[1][0] }, { shouldFocus: false });
      });
    }
    setCamaras((prevState) => ({
      ...prevState,
      is_loading: false,
    }));
  }
};
